import { css } from '@emotion/css';

import { SMALL_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const signaturesListClassName = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  marginBottom: Spacing.MD,
  [SMALL_DEVICE_MQ]: {
    borderRadius: 12,
    boxShadow:
      '0px 2px 4px 0px rgb(63, 63, 63, 0.1), 0px -1px 2px rgb(63, 63, 63, 0.075)',
    marginBottom: Spacing['2XL'],
  },
});
